import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import ListForms from './pages/listForms';
import CreateTemplate from './pages/createTemplate';
import Tabulation from './pages/tabulation';
import Pendency from './pages/pendency'
import CreateSkills from './pages/createSkills';
import Form from './pages/form';
import Home from './pages/home';
import Metrics from './pages/metrics';
import Clients from './pages/clients';
import Plan from './pages/plan';
import Users from './pages/users';

const MainRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/section" element={<Home />}>
        {/* Rota padrão da página Home */}
        <Route index element={<Navigate to="listForms" replace />} />
        <Route path="createForm" element={<Form key="create" create={true} mode="create" />} />
        <Route path="updateForm" element={<Form key="update" create={false} mode="update" />} />
        <Route path="listForms" element={<ListForms />} />
        <Route path="createTemplate" element={<CreateTemplate />} />
        <Route path="tabulation" element={<Tabulation />} />
        <Route path="pendency" element={<Pendency />} />
        <Route path="createSkills" element={<CreateSkills />} />
        <Route path="metrics" element={<Metrics />} />
        <Route path="clients" element={<Clients />} />
        <Route path="planTabulations" element={<Plan />} />
        <Route path="users" element={<Users />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MainRoutes;
